/**
 * THE-DOOR-TO-THE-BUILD-1 — which addresses belong to the public site resolver
 * and which belong to the product.
 *
 * WHAT WAS WRONG. The last three routes in `App.tsx` are
 * `/:slugOrUsername/:routePath`, `/:slugOrUsername`, then the wildcard. React
 * Router ranks a two segment parameterised route above a wildcard, so EVERY
 * two segment address the app does not register went to the resolver with the
 * first segment read as a business name. A merchant trimming their own address
 * was handed a lookup for a business called `dashboard`, and then the public
 * site's own miss page: unstyled, talking about publishing, with no way back
 * into the product, and a row written to `public_resolver_misses` for each
 * visit.
 *
 * The single segment case had been reasoned about — the wildcard's own comment
 * says so. The two segment case was added for project sub-pages like
 * `/my-site/about` and nobody asked what else it would swallow.
 *
 * WHY THIS IS SAFE, MEASURED RATHER THAN ASSUMED. Production, read with a five
 * second timeout: three published projects, all slugged `site-…`; sixty seven
 * profiles carrying a username; and NOT ONE project slug or username equal to
 * any name below. So no live page changes. It stays that way only while
 * nothing hands a merchant a slug or a username that is one of these words,
 * which nothing refuses today and which this wave raises rather than fixes.
 *
 * DECIDES, AND FETCHES NOTHING.
 */

/**
 * EVERY FIRST SEGMENT `App.tsx` REGISTERS.
 *
 * A guard reads the route table and fails if this list is missing one of them,
 * so a new top-level route cannot quietly become a business name. The guard is
 * the reason this list can be written down at all.
 */
export const RESERVED_FIRST_SEGMENTS: ReadonlyArray<string> = [
  '__connectors-preview',
  '__first-hello-preview',
  'acceptable-use',
  'affiliate-agreement',
  'affiliates',
  // THE-LINK-CANNOT-SIGN-YOU-IN-1 — /auth/confirm, where every emailed link
  // lands. The signup trigger already refuses `auth` as a username.
  'auth',
  'cancel',
  'dashboard',
  'first-build',
  'forgot-password',
  'i',
  'invite',
  'learn',
  'login',
  'onboarding',
  'onboarding-queue',
  'p',
  'portal',
  'pricing',
  'privacy',
  'q',
  'r',
  'reschedule',
  'reset-password',
  'signup',
  'sites',
  'terms',
  'widget',
]

/**
 * IS THIS ADDRESS THE PUBLIC SITE'S TO ANSWER?
 *
 * Only when its first segment is not one of the product's own. An empty
 * segment is nobody's: there is nothing to look up, and inventing a lookup for
 * it would be the same defect in a smaller form.
 */
export function isPublicAddress(firstSegment: string | undefined | null): boolean {
  const seg = typeof firstSegment === 'string' ? firstSegment.trim() : ''
  if (seg === '') return false
  return !RESERVED_FIRST_SEGMENTS.includes(seg.toLowerCase())
}
